import TestApi from '../api/test';
import TestResult from '../models/test/result';

const env = process.env;
const testApi = new TestApi(
  env.VUE_APP_API_TEST_URL,
  env.VUE_APP_API_TEST_TIMEOUT
);

const state = {
  results: {},
};

const getters = {
  getTestClientResults: state => clientId => {
    if (!state.results[clientId]) {
      return [];
    }

    return state.results[clientId];
  },
};

const mutations = {
  TEST_SET_RESULTS: (state, payload) => {
    const results = [];

    for (const item of payload.result) {
      results.push(new TestResult(item));
    }

    state.results[payload.clientId] = results;
    state.results = Object.assign({}, state.results);
  },
};

const actions = {
  TEST_LOAD_RESULTS: async (context, payload) => {
    const result = await testApi.getResults(context.rootState.token, payload);
    const data = { result: result.result, clientId: payload };

    context.commit('TEST_SET_RESULTS', data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
